module.exports = __webpack_public_path__ + "img/about-history-wheat.jpg?bef3b73cbfeb04b51bda0d2bff81908b";